import { type App, type ComponentInternalInstance, getCurrentInstance, type Reactive } from 'vue'
import type { TitropGlobal } from '@/composables/useTitrop.ts'
import { useTitrop } from '@/composables/useTitrop.ts'
import { rand } from '@vueuse/core'

declare module '@vue/runtime-core' {
  export interface ComponentCustomProperties {
    $titrop: Reactive<TitropGlobal>
  }
}
export default {
  install: (app: App) => {
    app.config.globalProperties.$titrop = useTitrop().value
    app.config.globalProperties.$user = useTitrop().value.user

    app.config.globalProperties.$id = (field?: string): string => {
      const curInst = getCurrentInstance()
      if (curInst === null) return `v-${rand(1000000000, 9999999999).toString()}`

      if (field) return `v-${curInst.uid}-${field}`
      else return `v-${curInst.uid.toString()}-${rand(1000000000, 9999999999)}`
    }

    //mixin the disable autocomplete blocker
    app.directive('block-autocomplete', {
      mounted: (el) => {
        el.setAttribute('readonly', 'readonly')
        el.setAttribute('autocomplete', 'off')
        el.setAttribute('value', '')
        setTimeout(() => {
          el.removeAttribute('readonly')
        }, 500)
      }
    })
  }
}

export function whenDev(eventHook: undefined | null | ((hook: () => void, target?: ComponentInternalInstance | null) => false | undefined), callable: () => void) {
  if (!import.meta.env.DEV) return
  if (eventHook) eventHook(callable)
  else callable()
}
